import { useCallback, Dispatch, SetStateAction, useState } from 'react';

import { useServerDataTableContext } from 'components/DataTable/ServerDataTable';
import { CreateSingleInspectionForm } from '../../CreateSingleInspection/CreateSingleInspectionForm';
import { InspectionUploadWorkflowComponentProps, Steps } from '../UploadInspectionDataModal';
import { ValidationProps } from './Validation';
import {
  AtlasGqlInspectionTask,
  AtlasGqlInternalBladeInspectionTask,
  AtlasGqlAsset,
  AtlasGqlInspection,
  AtlasGqlInspectionType,
} from 'types/atlas-graphql';

type SingleInspectionProps = Omit<InspectionUploadWorkflowComponentProps, 'uploadId'> & {
  onClose: () => void;
  setInspectionType: Dispatch<SetStateAction<AtlasGqlInspectionType>>;
  task?: (AtlasGqlInspectionTask | AtlasGqlInternalBladeInspectionTask) | null;
  asset?: AtlasGqlAsset | null;
  onSingleInspectionCreate?: () => void;
  setValidationStepProps: Dispatch<
    SetStateAction<Omit<ValidationProps, 'setStep' | 'setPendingStep' | 'rollback'>>
  >;
};

export const SingleInspection = ({
  step,
  onClose,
  setValidationStepProps,
  setInspectionType,
  onSingleInspectionCreate,
  setStep,
  setCreatedInspectionIds,
  setCreatedTaskIds,
  task,
  asset,
}: SingleInspectionProps) => {
  const { refetch } = useServerDataTableContext().context;
  const [hasNewInspectionTask, setHasNewInspectionTask] = useState<boolean>(false);

  const handleCreate = useCallback(
    async (inspection: AtlasGqlInspection | undefined) => {
      // conditonally refetch the inspection list
      refetch && (await refetch());

      if (onSingleInspectionCreate) {
        onSingleInspectionCreate();
      }

      /**
       * If creation was successful, proceed
       * If not, error toast will be shown (from child component), remain here to try again
       */
      if (inspection) {
        setValidationStepProps({
          inspection,
          hasNewInspectionTask,
        });
        setCreatedInspectionIds([inspection.id]);
        if (hasNewInspectionTask && inspection.taskId) {
          setCreatedTaskIds([inspection.taskId]);
        }
        if (inspection?.type) {
          setInspectionType(inspection.type);
        }
        setStep(Steps.SingleUploadValidation);
      }
    },
    [
      refetch,
      onSingleInspectionCreate,
      hasNewInspectionTask,
      setStep,
      setValidationStepProps,
      setInspectionType,
    ]
  );

  return (
    <>
      {step === Steps.SingleUpload && (
        <CreateSingleInspectionForm
          onClose={onClose}
          onCreate={handleCreate}
          setHasNewInspectionTask={setHasNewInspectionTask}
          task={task}
          asset={asset}
          saveButtonText="Next"
        />
      )}
    </>
  );
};
